require('./index.less');
var tpl = require('./index.html');
var locale = require('../../i18n');

var manager = {
    init: function() {
        $('#datasource-management').html(tpl({
            locale: locale()
        }));
        this.sourceEditor = Enhancer.Editor.createAutocompleteEditor( 
            'datasource-editor',
            { mode: 'sql', enableLiveAutocompletion: true }
        );
        this.$sourceList = $('#datasource-list');
        this.__bindEvent();
    },
    setDatasourceList: function(sources) {
        sources = sources || [];
        this.$sourceList.html('');
        for (var i = 0; i < sources.length; i++) {
            this.__appendDatasource(sources[i]);
        }
    },
    getDatasourceList: function() {
        return this.$sourceList.find('li').map(function() {
            return {
                id: $(this).attr('sourceId'),
                name: $(this).find('span.source-name').text() 
            }
        }).get();
    },
    __bindEvent: function() {
        var that = this;
        $('#add-datasource').button({
            icons: {
                primary: 'ui-icon-plus'
            }
        }).on('click', function(e) {
            that.__addDatasource();
        });

        $('#datasource-save').button({
            icons: {
                primary: 'ui-icon-disk'
            },
            disabled: true
        }).on('click', function() {
            if ($(this).hasClass('ui-state-disabled')) {
                return;
            }
            var $curr = that.$sourceList.find('li.ui-state-active');
            if (!$curr.size()) {
                return;
            }
            var source = {
                id:  $curr.attr('sourceId'),
                query: that.sourceEditor.getSession().getValue(),
                name: $curr.find('span.source-name').text()
            };
            Enhancer.DatasourceManager.setDatasource(source.id, source);
            Enhancer.Message.alert(locale('saved'));

        });

        $('#datasource-test').button({
            icons: {
                primary: 'ui-icon-play'
            }
        }).on('click', function() {
            var sql = that.sourceEditor.getSession().getValue();
            Enhancer.DatasourceManager.testSQL(sql, function(result) {
                if (result.success) {
                    Enhancer.Message.alert(
                        '<i class="ui-icon ui-icon-check" style="float:left; margin-right: 4px"></i>'
                        + locale('normal'));
                } else {
                    Enhancer.Message.alert(
                        '<i class="ui-icon ui-icon-close" style="float:left; margin-right: 4px"></i>'
                        + result.message);
                }
            }, function(err) {
                Enhancer.Message.alert(locale('syserr'));
                console.error(err);
            });
        });

        $('#datasource-delete').button({
            icons: {
                primary: 'ui-icon-cancel'
            },
            disabled: true
        }).on('click', function() {
            var $this = $(this);
            if ($(this).hasClass('ui-state-disabled')) {
                return;
            }
            var $curr = that.$sourceList.find('li.ui-state-active');
            if (!$curr.size()) {
                return;
            }
            Enhancer.Message.confirm({
                content: locale('datasourceDeleteTips'),
                confirm: function() {
                    var sourceId = $curr.attr('sourceId');
                    Enahncer.DatasourceManager.delDatasource(sourceId);
                    var $target = $curr.next();
                    if (!$target.length) {
                        $target = $curr.prev();
                    }
                    $curr.remove();

                    if ($target.length) {
                        $target.find('span.source-id').trigger('click');
                        return;
                    }
                    that.sourceEditor.getSession().setValue('');
                    $('#datasource-save').button('disable');
                    $('#datasource-delete').button('disable');
                },
                no: function() {
                    alert(2);
                }
            });
        });

        that.$sourceList.on('click', function(e) {
            if (e.target.tagName === 'SPAN' ) {
                var $li = $(e.target).parent();
                if ($li.hasClass('ui-state-active')) {
                    return;
                }
                $(this).find('li.ui-state-active').removeClass('ui-state-active');
                $li.addClass('ui-state-active');
                var sourceId = $li.attr('sourceId');
                Enhancer.DatasourceManager.getDatasource(sourceId, function(source) {
                    that.sourceEditor.getSession().setValue(source.query);
                    $('#datasource-save').button('enable');
                    $('#datasource-delete').button('enable');
                });
            }
        });
    },
    __addDatasource: function() {
        var name = $('#datasource-name').val();
        if (!/\w+/.test(name)) {
            return $('#datasource-name').effect('highlight');
        }
        if (name.length > 48) {
            return $('#datasource-name').effect('highlight');
        }
        var that = this;
        var source = {
            name: name,
            query: 'SELECT ...'
        };
        Enhancer.DatasourceManager.addDatasource(source, function(srcId) {
            source.id = srcId;
            that.__appendDatasource(source);
        });
    },
    __appendDatasource: function(source) {
        if (!source || !source.id) {
            return;
        }
        $('<li class="ui-widget-content">').attr('sourceId', source.id)
            .attr('title', source.name)
            .append('<span class="source-id ui-state-default">' + source.id + '</span>')
            .append('<span class="source-name">' + source.name + '</span>')
            .appendTo(this.$sourceList)
            .find('span.source-id').trigger('click');
    }
};

module.exports = manager;


/*****************
 ** WEBPACK FOOTER
 ** ./src/managers/datasource/index.js
 ** module id = 38
 ** module chunks = 0
 **/